module.exports = __webpack_public_path__ + "static/media/vine.54adb5af.webp";